











import { RoleName } from '@/shared/role-name';
import { Role } from '@/shared/roles/role';
import { User } from '@/shared/user';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const userModule = namespace('user');
const usersModule = namespace('users');

@Component
export default class UserRoles extends Vue {
    @userModule.Getter('user') private currentUser!: User;

    @usersModule.Getter('roles') private roles!: Array<Role>;

    @Prop({ required: true }) private user!: User;
    @Prop({ required: false, default: false }) private partnerPracticeUser!: boolean;

    private get filteredRoles(): Array<Role> {
        if (this.partnerPracticeUser) {
            return this.roles.filter((role) =>
                role.name.toLowerCase() === RoleName.LegalAdvisor.toLowerCase() ||
                role.name.toLowerCase() === RoleName.LegalAssistant.toLowerCase() ||
                role.name.toLowerCase() === RoleName.HoD.toLowerCase());
        }

        return this.roles.filter((role) => role.name.toLowerCase() !== RoleName.System.toLowerCase());
    }

    private get canEdit(): boolean {
        if (this.user.id == null) {
            return true;
        }

        return this.user.id !== this.currentUser.id!;
    }
}
